module.exports = __webpack_public_path__ + "img/sma.46e39748.png";